<template>
  <div>
    <el-form class="common_form" label-width="130px" label-position="left">
      <el-row>
        <el-col :span="24">
          <el-form-item label="线索基本信息">
            <el-checkbox-group v-model="formData.resourcePool">
              <el-checkbox v-for="(item, index) in (fieldlead[0]?fieldlead[0].sysPermissionList:[])" :key="index" :label="item.permissionId">{{ item.permissionName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="客户信息">
            <el-checkbox-group v-model="formData.resourceLead">
              <el-checkbox v-for="(item, index) in (fieldlead[1]?fieldlead[1].sysPermissionList:[])" :key="index" :label="item.permissionId">{{ item.permissionName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="活动信息">
            <el-checkbox-group v-model="formData.resourceActive">
              <el-checkbox v-for="(item, index) in (fieldlead[2]?fieldlead[2].sysPermissionList:[])" :key="index" :label="item.permissionId">{{ item.permissionName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="操作记录">
            <el-checkbox-group v-model="formData.resourceRecord">
              <el-checkbox v-for="(item, index) in (fieldlead[3]?fieldlead[3].sysPermissionList:[])" :key="index" :label="item.permissionId">{{ item.permissionName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="CRM反馈记录">
            <el-checkbox-group v-model="formData.resourceCrm">
              <el-checkbox v-for="(item, index) in (fieldlead[4]?fieldlead[4].sysPermissionList:[])" :key="index" :label="item.permissionId">{{ item.permissionName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formData: {
        resourcePool: [],
        resourceLead: [],
        resourceActive: [],
        resourceRecord: [],
        resourceCrm: []
      }
    };
  },
  props: {
    fieldlead: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    },
    trastlist: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  },
  watch: {
    trastlist () {
      let MissId = [];
      this.trastlist.forEach(item => {
        switch (item.optionType) {
          case 'lead_filed_lead_info':
            MissId = item.sysPermissionList.map(item => {
              return item.permissionId;
            });
            this.$set(this.formData, 'resourcePool', MissId);
            break;
          case 'lead_filed_customer_info':
            MissId = item.sysPermissionList.map(item => {
              return item.permissionId;
            });
            this.$set(this.formData, 'resourceLead', MissId);
            break;
          case 'lead_filed_activity_info':
            MissId = item.sysPermissionList.map(item => {
              return item.permissionId;
            });
            this.$set(this.formData, 'resourceActive', MissId);
            break;
          case 'lead_filed_operation_log':
            MissId = item.sysPermissionList.map(item => {
              return item.permissionId;
            });
            this.$set(this.formData, 'resourceRecord', MissId);
            break;
          case 'lead_filed_crm_log':
            MissId = item.sysPermissionList.map(item => {
              return item.permissionId;
            });
            this.$set(this.formData, 'resourceCrm', MissId);
            break;
        }
      });
    }
  },
  mounted () {
  },
  methods: {
  }
};
</script>

<style scoped>

</style>
